class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=10&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }
      
      var swiper = new Swiper(".search-drawer-slider.swiper", {
        slidesPerView: "auto",
        loop:true,
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 0.3,
          momentumVelocityRatio: 0.3,
        },
        speed: 1000,
      });

        if (window.innerWidth > 1024) {
          document.querySelectorAll('.grid-bottom .main-color-variant .color-var.click').forEach(function(element) {
            element.addEventListener('click', function(event) {
              event.preventDefault();
              var attVal = this.getAttribute('data-id');
              var productItem = this.closest('.product-item');
              var innerGrids = productItem.querySelectorAll('.snippet-product-grid .inner-product-grid');
              innerGrids.forEach(function(innerGrid) {
                if (attVal === innerGrid.getAttribute('data-id')) {
                  innerGrids.forEach(function(g) {
                    g.classList.remove('active');
                  });
                  innerGrid.classList.add('active');
                }
              });
            });
          });
          }

      
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
  menuBurger.addEventListener('click', function(e){
    document.body.classList.toggle('open-menu');
    const activeLi = document.querySelector('.mobile-nav > li.active');
    if (activeLi) {
      activeLi.classList.remove('active');
    }
    document.body.classList.remove('open-drawer','open-search','open-sort','open-filter');    
  });
});

document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter');
    setTimeout(function() {
      // document.querySelector(".main-search-bar #Search").focus();
      document.querySelector("#search-input").focus();
    }, 200);
  });
});
document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-menu,open-filter');
});
// Quick Add Button - Event Delegation
// Prepare BIS_trigger on sold-out variants when user hovers over them
var _bisCache = {};
var _bisFetching = {};
document.addEventListener('mouseover', function(e) {
  var li = e.target.closest('.variant-grid.sold-out');
  if (!li || li.querySelector('.BIS_trigger')) return;

  var grid = li.closest('.snippet-product-grid');
  var productHandle = grid?.dataset.id;
  if (!productHandle) return;

  function attachBIS(product) {
    if (li.querySelector('.BIS_trigger')) return;
    var link = document.createElement('a');
    link.href = '#';
    link.className = 'BIS_trigger';
    link.setAttribute('data-product-data', JSON.stringify(product));
    link.setAttribute('data-variant-id', li.dataset.id);
    link.style.cssText = 'position:absolute;inset:0;z-index:1;';
    li.style.position = 'relative';
    li.appendChild(link);
  }

  if (_bisCache[productHandle]) {
    attachBIS(_bisCache[productHandle]);
  } else {
    if (!_bisFetching[productHandle]) {
      _bisFetching[productHandle] = fetch('/products/' + productHandle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          _bisCache[productHandle] = product;
          return product;
        })
        .catch(function() { delete _bisFetching[productHandle]; });
    }
    _bisFetching[productHandle].then(function(product) {
      if (product) attachBIS(product);
    });
  }
});

// Handles all .variant-grid clicks (static and dynamic content)
document.addEventListener('click', function(e) {
  // BIS_trigger inside sold-out — let AMP handle it
  if (e.target.closest('.variant-grid.sold-out .BIS_trigger')) return;
  if (e.target.closest('.variant-grid.sold-out')) return;

  const variantGrid = e.target.closest('.variant-grid');
  if (!variantGrid) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = variantGrid.dataset.id;
  const errorGridOuter = variantGrid.closest('.snippet-product-grid');
  const errorGrid = errorGridOuter?.querySelector('.grid-error');

  if (typeof addToCart === 'function') {
    addToCart(variantId, {
      errorContainer: errorGrid
    });
  }
});
if(document.querySelector('.nav-wrap')){
  document.querySelectorAll('.nav-wrap').forEach(function(navWrap){
    navWrap.addEventListener('click',function(e){
      navWrap.closest('li').classList.toggle('active');
    });
  });
}
if(document.querySelector('.back-btn')){
  document.querySelectorAll('.back-btn').forEach(function(backBtn){
    backBtn.addEventListener('click',function(e){
      backBtn.closest('li.active').classList.remove('active');
    });
  });
}
if (window.innerWidth > 1024) {
   if(document.querySelector('.list-menu')){
    document.querySelectorAll('.list-menu > li').forEach(function(navList){
      navList.addEventListener('mouseover', function(){
        navList.classList.add('active');
      });
      navList.addEventListener('mouseout', function(){
        navList.classList.remove('active');
      });
    });
  }
}

document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search','open-size-chart','open-find-store');
  }
};


// HEADER JS
var lastScroll = 0;
const header = document.querySelector('#shopify-section-header');
const collectionHeader = document.querySelector('.coll-head');

const setVariables = () => {
  if (header && document.body.style.getPropertyValue('--header-height') !== `${header.offsetHeight}px`) {
    document.body.style.setProperty('--header-height', `${header.offsetHeight}px`);
  }
}

setVariables()

window.addEventListener('scroll', () => {
  let scrollCount = window.pageYOffset;
  setVariables()

  if (scrollCount > 300) {
    document.body.classList.add('scroll-active');
    setTimeout(function () {
      if (scrollCount > lastScroll) {
        document.body.classList.remove('scroll-up');
        document.body.classList.add('scroll-down');
      } else if (scrollCount < lastScroll) {
        document.body.classList.remove('scroll-down');
        document.body.classList.add('scroll-up');
      }
      lastScroll = scrollCount;
    }, 0);
  } else {
    document.body.classList.remove('scroll-active', 'scroll-up', 'scroll-down');
    lastScroll = scrollCount;
  }
});

if (window.innerWidth < 1025) {
document.addEventListener("click", function (event) {
  if (event.target.closest(".close-search-btn")) {
    document.getElementById('search-input').value = '';
    document.querySelector('body').classList.remove("open-search");
    const predictiveSearch = document.getElementById("predictive-search");
    document.querySelectorAll('.searchlist').forEach(el => {
      el.classList.remove('active');
    });
    if (predictiveSearch) {
      predictiveSearch.style.display = "none";
    }
    const searchInput = document.getElementById("Search");
    if (searchInput) {
      searchInput.value = "";
    }
  }
});
}

// if (window.innerWidth > 1024) {
//   window.addEventListener("scroll", function () {
//     if (document.body.classList.contains("open-search")) {
//       document.body.classList.remove("open-search");
//       const predictiveSearch = document.getElementById("predictive-search");
//       if (predictiveSearch) {
//         predictiveSearch.style.display = "none";
//       }
//       const searchInput = document.getElementById("Search");
//       if (searchInput) {
//         searchInput.value = "";
//       }
//     }
//   });
// }


// wishlist click
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.wishlist-btn');
  if (!btn) return; // exit if not clicked on a wishlist button
  const grid = btn.closest('.snippet-product-grid');
  if (grid) {
    grid.classList.add('open-wishlist');
  }
  btn.querySelector('span').textContent = 'Select Size for Wishlist';
});

document.addEventListener('mouseout', function (e) {
  const grid = e.target.closest('.snippet-product-grid');
  if (!grid) return;

  // Only trigger when the mouse actually leaves the grid
  if (!grid.contains(e.relatedTarget)) {
    if (grid.classList.contains('open-wishlist')) {
      grid.classList.remove('open-wishlist');
      grid.querySelectorAll('.wishlist-btn').forEach(btn => {
        btn.querySelector('span').textContent = 'Add to wishlist';
      });
    }
  }
});

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.wishlist-bar li.btn-link');
  if (!btn) return;

  const dataId = btn.getAttribute('data-id');
  if (!dataId) return;

  const productItem = btn.closest('.snippet-product-grid .inner-product-grid.active');
  if (!productItem) return;

  const wlButton = productItem.querySelector('.th_wl_col_btn');
  if (!wlButton) return;

  wlButton.setAttribute('data-variant_id', dataId);
  const wlProduct = wlButton.getAttribute('data-product_id');
  document.querySelector(`.th_wl_col_btn[data-product_id="${wlProduct}"] .wc_wishlistBlock`).click();

  const grid = e.target.closest('.snippet-product-grid');
  if (!grid) return;
  grid.classList.remove('open-wishlist');

  // if (typeof wcPacificWishlistWidget === 'function') {
  //   wcPacificWishlistWidget('.th_wl_col_btn', wlProduct, 'collection');
  // }
  // await new Promise(resolve => setTimeout(resolve, 100));
  // const targetSelector = `.th_wl_col_btn[data-product_id="${wlProduct}"][data-variant_id="${dataId}"] .wc_wishlistBlock`;
  // const targetBtn = document.querySelector(targetSelector);
  // const targetBtn = wlButton.querySelector('.wc_wishlistBlock');
  // if (targetBtn) {
  //   targetBtn.click();
  //   productItem.querySelectorAll('.wishlist-btn').forEach(btn => {
  //     btn.textContent = 'Added to wishlist';
  //   });
  //   productItem.classList.add('wishlist-added');
  // } else {
  //   console.warn('⚠️ Wishlist block not found for selector:', targetSelector);
  // }
});


// JD Country Code
document.addEventListener("DOMContentLoaded", function () {
    var countryRetryCount = 0;
    var maxCountryRetries = 50;

    function clearCountryPendingState() {
      document.documentElement.classList.remove("country-content-pending");
    }

    function checkShopifyCountry() {
      if (typeof Shopify !== "undefined" && Shopify.country) {
        var country = Shopify.country;
        if (country === "AU") {
          document.querySelectorAll(".section-cuntry-AU").forEach(function(el) {
            el.classList.remove("hidden");
          });
          document.querySelectorAll(".section-cuntry-globle").forEach(function(el) {
            el.classList.add("hidden");
          });
        } else {
          document.querySelectorAll(".section-cuntry-AU").forEach(function(el) {
            el.classList.add("hidden");
          });
          document.querySelectorAll(".section-cuntry-globle").forEach(function(el) {
            el.classList.remove("hidden");
          });
        }
        clearCountryPendingState();
      } else {      
        countryRetryCount += 1;

        if (countryRetryCount >= maxCountryRetries) {
          clearCountryPendingState();
          return;
        }

        setTimeout(checkShopifyCountry, 100);
      }
    }

    checkShopifyCountry();
  });


   let currentlyActiveAccordionItem = null;
const accordionItemHeaders = document.querySelectorAll(".snippet-faq-block .accordian-title");

accordionItemHeaders.forEach(accordionItemHeader => {
  accordionItemHeader.addEventListener("click", event => {
    const parentWrap = accordionItemHeader.closest(".accordian-wrap");
    const accordionItemBody = accordionItemHeader.nextElementSibling;
    if (currentlyActiveAccordionItem && currentlyActiveAccordionItem !== parentWrap) {
      currentlyActiveAccordionItem.classList.remove("active");
      const previouslyActiveBody = currentlyActiveAccordionItem.querySelector(".accordian-content");
      if (previouslyActiveBody) previouslyActiveBody.style.maxHeight = 0;
    }
    parentWrap.classList.toggle("active");
    currentlyActiveAccordionItem = parentWrap;

    if (parentWrap.classList.contains("active")) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
    } else {
      accordionItemBody.style.maxHeight = 0;
    }
  });
});


function giftProduct() {
  if (window.giftProductBound) return;
  window.giftProductBound = true;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.free_pd_btn');
    if (!btn) return;

    const variantId = btn.dataset.id;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          _gift_product: true
        }
      })
    })
    .then(r => r.json())
    .then(data => {
      load_cart();
      document.querySelector('body').classList.add('open-drawer');
    })
    .catch(err => console.error(err));
  });
}

giftProduct();
